import React, { Component } from "react";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import CanvasJSReact from "../../assets/canvas/canvasjs.react";
import { connect } from "react-redux";
import { listCooperative } from "../../actions/dashboard/pusat_action";
import {
  getDashboardData,
  getDashboardPending,
} from "../../reducers/dashboard/pusat_reducer";
import { listBranch } from "../../actions/master-data/branch_action";
import {
  getListBranch,
  getBranchPending,
} from "../../reducers/master-data/branch_reducer";
import SelectComponent from "../../components/form/SelectComponent";
import { dashboardCardStyles as dash } from
  "./dashboardCardStyles";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class CardRegistrasiPPDS extends Component {
  componentDidMount() {
    this.props.listCooperative();
    // this.props.listBranch()
  }
  constructor() {
    super();
    this.state = {
      branch_id: null,
      duration: 2,
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
  }

  handleSelectChange(e) {
    this.setState({ duration: 0.1 });
    if (e) {
      this.setState({ branch_id: e.value });
      this.props.listCooperative({ branch_id: e.value });
    } else {
      this.props.listCooperative();
    }
  }

  handleYearSelectChange(e) {
    const { branch_id } = this.state;
    this.setState({ year: e });
    if (e) {
      this.props.listCooperative({
        start_year: e.value - 5,
        end_year: e.value,
        branch_id: branch_id,
      });
    } else {
      this.props.listCooperative();
    }
  }

  render() {
    const {
      listCooperative_data,
      listBranch_data,
      listBranch_pending,
      listCooperative_pending,
    } = this.props;
    let data = [],
      branchOptions = [],
      result = null;
    if (listBranch_data && listBranch_data.length !== 0) {
      branchOptions = listBranch_data.data.map(({ name, id }) => {
        return { label: name, value: id };
      });
    }
    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    for (let i = currentYear; i >= 1900; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }
    if (listCooperative_data) {
      data = listCooperative_data.map(({ year, total }) => ({
        label: year,
        y: total,
      }));
      const options = {
        animationEnabled: true,
        height: 240,
        axisX: {
          valueFormatString: "YYYY",
        },
        axisY: {
          includeZero: true,
          gridThickness: 0,
        },
        data: [
          {
            xValueFormatString: "YYYY",
            type: "splineArea",
            lineColor: "#F6C269",
            color: "#FCEBCD",
            lineThickness: 8,
            markerColor: "white",
            markerBorderColor: "#F6C269",
            markerBorderThickness: 4,
            markerSize: 10,
            dataPoints: data,
          },
        ],
      };
      result = (
        <CanvasJSChart
          options={options}
          /* onRef={ref => this.chart = ref} */
        />
      );
    }

    if (listBranch_pending || listCooperative_pending) {
      result = null;
    }

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <Column
          style={{
            boxShadow: "0px 3px 6px #00000029",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            height: "100%",
            width: "100%",
            minHeight: 300,
            backgroundColor: "white",
          }}
        >
          <div className={css(styles.cardHeader)}></div>

          <div className={css(dash.header, styles.borderBottom)}>
            <label className={css(dash.title)}>
              Keanggotaan Koperasi Member PABOI
            </label>
            <div className={css(dash.filters)}>
              <div className={css(dash.fieldNarrow)}>
                <SelectComponent
                  options={yearOptions}
                  isRounded
                  onChange={this.handleYearSelectChange}
                  placeholder="Pilih Tahun"
                />
              </div>
              <div className={css(dash.field)}>
                <SelectComponent
                  options={branchOptions}
                  isRounded
                  onChange={this.handleSelectChange}
                  placeholder="Pilih Cabang"
                />
              </div>
            </div>
          </div>
          <Column className={css(dash.chartBody)}>
            {result && result !== null ? result : "Loading.."}
          </Column>
        </Column>
      </div>
    );
  }
}

function mapStateToProps({ listCooperative_pusat, listBranch }) {
  return {
    listCooperative_data: getDashboardData(listCooperative_pusat),
    listCooperative_pending: getDashboardPending(listCooperative_pusat),
    listBranch_data: getListBranch(listBranch),
    listBranch_pending: getBranchPending(listBranch),
  };
}

export default connect(mapStateToProps, {
  listCooperative,
  listBranch,
})(CardRegistrasiPPDS);

const styles = StyleSheet.create({
  titleLabel: {
    color: "#495057",
    fontSize: 18,
    fontWeight: "bold",
    margin: "5px 0",
  },
  cardLabel: {
    color: "#495057",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 4,
  },
  wrapper: {
    // padding: 15,
    // height: 400,
    backgroundColor: "white",
  },
  borderBottom: {
    borderBottom: "1px solid #eeee",
  },
  cardHeader: {
    backgroundColor: "#F6C269",
    height: 10,
    width: "100%",
  },
});
